import React from 'react';

import Flag from '../flag/Flag';
import Select from './Select';

const customOptionLabel = option => (
  <div className='flex-container row space-between align-center pr5-sm u-full-width'>
    {option.label}
    <Flag countryCode={option.value} />
  </div>
);

const CountrySelect = props => <Select customOptionLabel={customOptionLabel} {...props} />;

export default CountrySelect;
